/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from "react";
import { useState, useEffect, useCallback } from "react";
import { Row } from "reactstrap";
import { Speaking } from "../../../pages/quiz/speaking";
import { ShowQuestions } from "../../../pages/quiz/ShowQuestions";
import { TextArea } from "../../../components/writting_essay/textarea";
import { exerciseType } from "../../../components/constants/constants";
import { find } from "lodash";
import B2CDescription from "../../../pages/b2c_assessment/B2C_Description";
import { B2CResizableContent } from "../../../pages/b2c_assessment/B2C_ResizableContent";
import { B2CAssessmentFeedback } from "../../../pages/b2c_assessment/B2C_AssessmentFeedback";
import { AudioPlayer } from "../../../components/listening_exercise/audio_player";
import { Card } from "../../components/ui/card";
import { ElabMobileAssessment } from "./ElabMobileAssessment";
// import { useCustomOrigin } from "../../../components/custom_origin/CustomOriginContext";

export const ElabQuizBody = ({
  exercise,
  isReview,
  setIsonRecorder,
  additionalResourceToggle,
  setSpeakingUrl,
  currentPage,
  resetAudio,
  setresetAudio,
  onblur,
  answers,
  section_id,
  page_id,
  data,
  visualizerToggle,
  setessayWordsCount,
  isAiGradingexercise,
  GWarningToggle,
  AisubmissionCounter,
  lastexerciseId,
}) => {
  // let customOrigin = useCustomOrigin();
  let found_section = find(answers, ["section_id", section_id]);
  let found_page = find(answers, ["page_id", page_id]);
  let found_exercise = find(answers, ["exercise_id", exercise.id]);
  let [wordsCounter, setWordsCount] = useState(0);
  let [Answerslength, setAnswerslength] = useState();
  const [isQuesCollapsed, setIsQuesCollapsed] = useState(false);
  const [isfeedbackCollapsed, setIsfeedbackCollapsed] = useState(false);
  const [height, setHeight] = useState();
  const [isMobileView, setisMobileView] = useState(false);

  const observedDiv = useRef(null);

  useEffect(() => {
    if (!observedDiv.current) {
      return;
    }
    const resizeObserver = new ResizeObserver(() => {
      if (observedDiv.current?.offsetHeight !== height) {
        setHeight(observedDiv.current?.offsetHeight - 50);
      }
      if ((observedDiv.current?.offsetWidth + 10) < 1000) {
        setisMobileView(true);
      } else {
        setisMobileView(false);
      }
    });

    resizeObserver.observe(observedDiv.current);
    return function cleanup() {
      resizeObserver.disconnect();
    };
  });
  const QuesCollapse = () => {
    setIsQuesCollapsed(!isQuesCollapsed);
  };
  const essayWordsCounter = useCallback(
    (wordsCounter) => {
      setessayWordsCount(wordsCounter);
    },
    [setessayWordsCount]
  );

  const feedbackCollapse = () => {
    setIsfeedbackCollapsed(!isfeedbackCollapsed);
  };
  useEffect(() => {
    setAnswerslength(answers.length === 0 ? 0 : 0);
    setWordsCount(
      found_section &&
        found_page &&
        found_exercise &&
        found_section.answers &&
        typeof found_section.answers === "string" &&
        exercise.task_type === exerciseType.WRITING_TASK
        ? found_section.answers.replace(/[\n]/g, " ").trim().split(" ").length
        : 0
    );
  }, [answers, found_section, found_page, found_exercise, exercise]);
  const handleCopyPaste = (e) => {
    if (!exercise.allow_copy_paste) {
      e.preventDefault();
    }
  };
  let words_count, written_text;
  const textarea_change = (e) => {
    written_text = e.target.value;
    answers = written_text;
    words_count = written_text.replace(/[\n]/g, " ").trim().split(" ").length;
    setAnswerslength(words_count);
    if (!written_text) {
      words_count = 0;
    }
    setWordsCount(words_count);
  };
  let text_area_date = null;
  if (found_section && found_page && found_exercise) {
    text_area_date = found_section.answers;
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    essayWordsCounter(wordsCounter);
  }, [essayWordsCounter, wordsCounter]);

  const handleScroll = (e) => {
    var timer;
    const container = e.target ;
    if (container)
    {
      container.classList.add('scrollable_scroll');
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      container.classList.remove('scrollable_scroll');
    }, 1200);
  };
  // useEffect(() => {
  //   if(!isB2B.some(domain => customOrigin.includes(domain)))
  //   {
  //     console.log("gvyucbiwsdv");
  //   if (data?.is_anonymous_user && data?.ai_grading_tasks_count > 0)
  //   {
  //     GWarningToggle();
  //   }
  //   else if (data?.is_premium && !isReview && data?.ai_grading_tasks_count > 0)
  //   {
  //     let ShowAiGradingWarning = localStorage.getItem(`gradingpopup${data.id}${data.school_student_id}${data.student_assessment_id}`);
  //     if(!ShowAiGradingWarning && AisubmissionCounter <= 0)
  //     {
  //       localStorage.setItem(
  //         `gradingpopup${data.id}${data.school_student_id}${data.student_assessment_id}`,
  //         true);
  //       GWarningToggle();
  //     }
  //     else if(!ShowAiGradingWarning){
  //       localStorage.setItem(
  //         `gradingpopup${data.id}${data.school_student_id}${data.student_assessment_id}`,
  //         true);
  //     }
  //   }
  //   }
  // }, [isAiGradingexercise,data,AisubmissionCounter,isReview, customOrigin]);
  const quizbodyClass = isMobileView ? "" : "elabsub_body";
  return (
    <>
      <div className="container mx-auto px-4 -mt-8">
        <Card className={`p-8 bg-white shadow-lg rounded-xl ${quizbodyClass}`}>
      {(exercise.task_instructions || exercise.audio) && !isReview && (
        <Row className="bg-white b2c-p-3 py-3 mb-3 bsm-ps-2">
          {exercise.task_instructions && (
            <B2CDescription
              description={
                <div
                  spellcheck="false"
                  data-gramm="false"
                  dangerouslySetInnerHTML={{
                    __html: `${exercise.task_instructions
                      .replace(/\[\[.*?\]\]\.\s*/g, "")
                      .replace(/\[\[.*?\]\]\s*/g, "")}`,
                  }}
                />
              }
            />
          )}
          {exercise.audio ? (
            <div key={exercise.id}>
              {" "}
              <AudioPlayer
                data={exercise}
                studentid={data.school_student_id}
                studentAssessmentId={data.student_assessment_id}
              />{" "}
            </div>
          ) : null}
        </Row>
      )}
      {isMobileView ? (
        <ElabMobileAssessment
          exercise={exercise}
          isReview={isReview}
          setIsonRecorder={setIsonRecorder}
          setSpeakingUrl={setSpeakingUrl}
          currentPage={currentPage}
          resetAudio={resetAudio}
          setresetAudio={setresetAudio}
          onblur={onblur}
          answers={answers}
          section_id={section_id}
          page_id={page_id}
          data={data}
          text_area_date={text_area_date}
          handleCopyPaste={handleCopyPaste}
          textarea_change={textarea_change}
          Answerslength={Answerslength}
          wordsCounter={wordsCounter}
          observedDiv={observedDiv}
        />
      ) : (
        <>
          {isQuesCollapsed && isReview ? (
            <Row className="bg-white  text-end mb-3">
              <div className="z-index-1">
                <button
                  type="button"
                  className="btn px-0"
                  onClick={QuesCollapse}
                >
                  <svg
                    width="14"
                    height="8"
                    viewBox="0 0 14 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L7 7L13 1"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </Row>
          ) : (
            <>
              {isReview && (
                <Row className="bg-white  text-end z-index-1 border-bottom-0">
                  <div className="pt-1">
                    <button
                      type="button"
                      className="btn p-0"
                      onClick={QuesCollapse}
                    >
                      <svg
                        width="14"
                        height="8"
                        viewBox="0 0 14 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 7L7 1L1 7"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </Row>
              )}
              <div
                className={
                  isReview &&
                  exercise.task_type !== exerciseType.WRITING_TASK &&
                  exercise.questions &&
                  exercise.questions?.length === 1 &&
                  (exercise.questions[0].ai_feedback || exercise.ai_grading_task) ?
                  "collapse__content row mb-3 bg-white"
                  :isReview
                    ? "collapse__content row b2c-sm-mb-3 bg-white "
                    : "row b2c-sm-mb-3 bg-white "
                }
                ref={observedDiv}
                onScroll={handleScroll}
                style={
                  exercise.html_content
                    ? { flex: 1, overflow: "hidden" }
                    : { flex: 1, overflow: "scroll" }
                }
              >
                <>
                  {exercise.html_content ? (
                    <Row
                      key={exercise.id}
                      className="b2c-p-3 py-4 resizeContainer"
                    >
                      <B2CResizableContent
                        exercise={exercise}
                        isReview={isReview}
                        setIsonRecorder={setIsonRecorder}
                        setSpeakingUrl={setSpeakingUrl}
                        currentPage={currentPage}
                        resetAudio={resetAudio}
                        setresetAudio={setresetAudio}
                        onblur={onblur}
                        answers={answers}
                        section_id={section_id}
                        page_id={page_id}
                        data={data}
                        text_area_date={text_area_date}
                        handleCopyPaste={handleCopyPaste}
                        textarea_change={textarea_change}
                        Answerslength={Answerslength}
                        wordsCounter={wordsCounter}
                        height={height}
                        handleScroll={handleScroll}
                        container={observedDiv.current}
                      />
                    </Row>
                  ) : (
                    <>
                      {exercise.task_type === exerciseType.WRITING_TASK ? (
                        <div key={exercise.id}>
                          <Row className="b2c-p-3 py-3">
                            <div className={"ps-1"} style={{ width: "75%" }}>
                              <TextArea
                                style={
                                  exercise.task_instructions
                                    ? { minHeight: "52dvh" }
                                    : { minHeight: "65dvh" }
                                }
                                className="answer-area"
                                data-question-type="writing"
                                data-tc="writitng-text"
                                data-section-id={section_id}
                                data-page-id={page_id}
                                data-exercise-id={exercise.id}
                                defaultValue={text_area_date}
                                onCopy={handleCopyPaste}
                                onPaste={handleCopyPaste}
                                value={isReview ? exercise.answers : null}
                                onchange={textarea_change}
                                onBlur={onblur}
                              />
                              <Row
                                className="bg-white px-4 py-2 g-0 border-top"
                                key={`${page_id}${section_id}${exercise.id}`}
                              >
                                <span className="text-muted">
                                  {" "}
                                  Words:{" "}
                                  {Answerslength === 0
                                    ? Answerslength
                                    : wordsCounter}{" "}
                                  words{" "}
                                </span>
                              </Row>
                            </div>
                          </Row>
                        </div>
                      ) : (
                        <Row key={exercise.id} className="b2c-p-3 py-3">
                          <div className="ps-3" style={{ width: "75%" }}>
                            {exercise.task_type === "Speaking Task" ||
                            exercise.task_type ===
                              exerciseType.PRONUNCIATION_TASK ? (
                              <Speaking
                                speakingUrl={setSpeakingUrl}
                                setIsonRecorder={setIsonRecorder}
                                data_section_id={section_id}
                                data_page_id={page_id}
                                answers={answers}
                                resetAudio={resetAudio}
                                setresetAudio={setresetAudio}
                                data_exercise_id={exercise.id}
                                data_type={data.type}
                                speaking_data={
                                  exercise.speaking_plain_text_for_ml
                                }
                                isReview={isReview}
                                speakingResponseURL={
                                  exercise.listening_file_url
                                }
                                Studentname={data.school_student_name}
                              />
                            ) : (
                              <div>
                                <ShowQuestions
                                  exercise_id={exercise.id}
                                  section_id={section_id}
                                  page_id={page_id}
                                  questions={exercise.questions}
                                  task_type={exercise.task_type}
                                  currentPage={currentPage}
                                  onAnswer={onblur}
                                  isReview={isReview}
                                  answer={answers}
                                  status={exercise.status}
                                  data={data}
                                  ai_grading_exercise={exercise.ai_grading_task}
                                />
                              </div>
                            )}
                          </div>
                        </Row>
                      )}
                    </>
                  )}
                </>
              </div>{" "}
            </>
          )}
          {isReview &&
          exercise.task_type !== exerciseType.WRITING_TASK &&
          exercise.questions &&
          exercise.questions?.length === 1 &&
          (exercise.questions[0].ai_feedback || exercise.ai_grading_task) ? (
            <>
              {isfeedbackCollapsed ? (
                <Row className="bg-white  mb-3">
                  <div className="col-12 d-flex z-index-1 ps-3">
                    <div className="col-6 ps-1 align-self-center d-flex align-items-center">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.8125 13.8594V10.7344M2.8125 4.48438V1.35938M1.25 2.92188H4.375M1.25 12.2969H4.375M8.125 1.98438L7.04114 4.80241C6.86488 5.26068 6.77675 5.48982 6.63971 5.68255C6.51824 5.85337 6.369 6.00262 6.19818 6.12408C6.00544 6.26113 5.77631 6.34926 5.31804 6.52551L2.5 7.60938L5.31804 8.69324C5.77631 8.86949 6.00544 8.95762 6.19818 9.09467C6.369 9.21613 6.51824 9.36538 6.63971 9.5362C6.77675 9.72893 6.86488 9.95807 7.04114 10.4163L8.125 13.2344L9.20886 10.4163C9.38512 9.95807 9.47325 9.72893 9.61029 9.5362C9.73176 9.36538 9.881 9.21613 10.0518 9.09467C10.2446 8.95762 10.4737 8.86949 10.932 8.69324L13.75 7.60938L10.932 6.52551C10.4737 6.34926 10.2446 6.26113 10.0518 6.12408C9.881 6.00262 9.73176 5.85337 9.61029 5.68255C9.47325 5.48982 9.38512 5.26068 9.20886 4.80241L8.125 1.98438Z"
                          stroke="#2E58D4"
                          stroke-width="1.25"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>

                      <b className="ps-2">AI feedback</b>
                    </div>
                    <div className="col-6 text-end">
                      <button
                        type="button"
                        className="btn px-0"
                        onClick={feedbackCollapse}
                      >
                        <svg
                          width="14"
                          height="8"
                          viewBox="0 0 14 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L7 7L13 1"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </Row>
              ) : (
                <>
                  <Row className="bg-white  z-index-1 border-bottom-0">
                    <div className="col-12 d-flex ps-3">
                      <div className="pt-1 col-6 ps-1 d-flex align-items-center">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.8125 13.8594V10.7344M2.8125 4.48438V1.35938M1.25 2.92188H4.375M1.25 12.2969H4.375M8.125 1.98438L7.04114 4.80241C6.86488 5.26068 6.77675 5.48982 6.63971 5.68255C6.51824 5.85337 6.369 6.00262 6.19818 6.12408C6.00544 6.26113 5.77631 6.34926 5.31804 6.52551L2.5 7.60938L5.31804 8.69324C5.77631 8.86949 6.00544 8.95762 6.19818 9.09467C6.369 9.21613 6.51824 9.36538 6.63971 9.5362C6.77675 9.72893 6.86488 9.95807 7.04114 10.4163L8.125 13.2344L9.20886 10.4163C9.38512 9.95807 9.47325 9.72893 9.61029 9.5362C9.73176 9.36538 9.881 9.21613 10.0518 9.09467C10.2446 8.95762 10.4737 8.86949 10.932 8.69324L13.75 7.60938L10.932 6.52551C10.4737 6.34926 10.2446 6.26113 10.0518 6.12408C9.881 6.00262 9.73176 5.85337 9.61029 5.68255C9.47325 5.48982 9.38512 5.26068 9.20886 4.80241L8.125 1.98438Z"
                            stroke="#2E58D4"
                            stroke-width="1.25"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>

                        <b className="ps-2">AI feedback</b>
                      </div>
                      <div className=" pt-1 col-6 text-end">
                        <button
                          type="button"
                          className="btn p-0"
                          onClick={feedbackCollapse}
                        >
                          <svg
                            width="14"
                            height="8"
                            viewBox="0 0 14 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13 7L7 1L1 7"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </Row>
                  <Row
                    key={exercise.id}
                    onScroll={handleScroll}
                    style={{ flex: 1, overflow: "scroll" }}
                    className="bg-white b2c-p-3 py-3 b2c-sm-mb-3 collapse__content ps-2"
                  >
                    <div>
                      <div style={{ width: "75%" }}>
                        <B2CAssessmentFeedback
                          questions={exercise.questions}
                          currentPage={currentPage}
                          isReview={isReview}
                          status={exercise.status}
                          ai_grading_exercise={exercise.ai_grading_task}
                        />
                      </div>
                    </div>
                  </Row>
                </>
              )}
            </>
          ) : null}
        </>
      )}
        </Card>
      </div>
    </>
  );
};
